import { render } from "./ArticleLoginWall.vue?vue&type=template&id=98f23b5a"
import script from "./ArticleLoginWall.vue?vue&type=script&lang=js"
export * from "./ArticleLoginWall.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__